import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import ProjectsSelect from "../../elements/projects/ProjectsSelect";
import DefaultButton from "../../styles/materialButtonStyle";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../../elements/notification/Notification";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import ServiceFieldsInput from "../../elements/services/ServiceFieldsInput";
import { useTranslation } from "react-i18next";

import { StyledAddService } from "../styledServices";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import MaterialDialog from "../../styles/materialDialog";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";

const AddService = ({ serviceID }) => {
  const { t } = useTranslation("servicePage");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [connectionData, setConnectionData] = useState({
    service: serviceID,
    project: null,
    name: null,
    twofa: null,
    connectionFields: []
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const createConnection = async () => {
    setLoading(true);

    let check2Fa = await check2FA(getUserInfo()["userId"], connectionData.twofa);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      setLoading(false);

      return;
    }

    for (let item in connectionData.connectionFields) {
      if (connectionData.connectionFields[item] instanceof File) {
        let formData = new FormData();
        formData.append("file", connectionData.connectionFields[item]);
        await axios.post("/api/media-objects", formData, { ...userAuthenticationConfig(false, true) }).then(response => {
          if (response.status === HTTP_STATUSES.HTTP_CREATED) {
            connectionData.connectionFields[item] = response.data.filePath;
          }
        }).catch(error => {
          parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
        });
      }
    }

    let data = {
      service: serviceID,
      project: connectionData.project.id,
      connectionFields: connectionData.connectionFields,
      name: connectionData.name
    };

    axios.post("/api/connections", data, userAuthenticationConfig(false)).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        setNotification({ ...notification, visible: true, type: "success", message: t("details.addForm.success") });
      }
      setOpen(false);
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleClose = () => {
    setConnectionData({
      service: serviceID,
      project: null,
      name: null,
      twofa: null,
      connectionFields: null
    });
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledAddService>
        <DefaultButton
          color="success"
          onClick={handleClickOpen}
        >
          {t("details.addForm.create")}
        </DefaultButton>
        <MaterialDialog
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("details.addForm.title")}
            </StyledDialogHead>
            <StyledDialogContent>
              <ProjectsSelect
                checkedProjects={connectionData.project}
                setCheckedProjects={(data) => setConnectionData({ ...connectionData, project: data })}
                isObject={true}
              />
              <ServiceFieldsInput
                serviceId={serviceID}
                connectionFields={connectionData.connectionFields}
                setCheckedFields={(data) => setConnectionData({ ...connectionData, connectionFields: data })}
              />
              <TextField
                id="name"
                label={t("details.addForm.name")}
                value={connectionData.name}
                onChange={(data) => setConnectionData({ ...connectionData, name: data.target.value })}
              />
              <TextField
                id="twofa"
                label={t("details.addForm.twoFa")}
                value={connectionData.twofa}
                onChange={(data) => setConnectionData({ ...connectionData, twofa: data.target.value })}
              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={loading}
              >
                {t("details.addForm.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={createConnection}
                color="success"
                disabled={loading || !connectionData.project || !connectionData.name || !connectionData.twofa}
              >
                {t("details.addForm.create")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </StyledAddService>
    </>
  );
};

export default AddService;